export const TextFilter = (props) => {
  let { value, set, placeholder, name } = props;

  return (
    <div className="uk-search uk-search-default uk-form-custom uk-margin-small-right">
      {!!value ? (
        <a
          className="uk-form-icon-flip uk-form-icon"
          uk-icon="icon: close"
          onClick={() => {
            set("");
          }}
        ></a>
      ) : (
        <span className="uk-search-icon-flip" uk-search-icon="true" />
      )}
      <input
        className="uk-search-input"
        type="search"
        placeholder={placeholder || name || ""}
        value={value}
        onChange={(e) => {
          set(e.target.value);
        }}
      />
    </div>
  );
};
